import { render, staticRenderFns } from "./allocationAudit.vue?vue&type=template&id=42ccd03c&scoped=true&"
import script from "./allocationAudit.vue?vue&type=script&lang=js&"
export * from "./allocationAudit.vue?vue&type=script&lang=js&"
import style0 from "./allocationAudit.vue?vue&type=style&index=0&id=42ccd03c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccd03c",
  null
  
)

export default component.exports